/**
 * TIMEZONE_OPTIONS — shared timezone list for clock components.
 * Used by JxClockOptionsDialog (optionBuilder) and clockCommand (CommandBar autocomplete).
 *
 * label — short display name shown in dropdowns (city only, no continent prefix)
 * value — full IANA timezone string passed to the clock component
 */
export const TIMEZONE_OPTIONS = [
    // Europe
    { label: 'Amsterdam', value: 'Europe/Amsterdam' },
    { label: 'London', value: 'Europe/London' },
    { label: 'Paris', value: 'Europe/Paris' },

    { label: 'Hong Kong', value: 'Asia/Hong_Kong' },

    // America
    { label: 'New_York', value: 'America/New_York' },
    { label: 'Chicago', value: 'America/Chicago' },
    { label: 'Denver', value: 'America/Denver' },
    { label: 'Phoenix', value: 'America/Phoenix' },
    { label: 'Los_Angeles', value: 'America/Los_Angeles' },
    { label: 'Anchorage', value: 'America/Anchorage' },
];
